export default function Step({ number, title, active, done }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div
        style={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 13,
          fontWeight: 700,
          flexShrink: 0,
          background: done ? "#1e3a5f" : active ? "#2563eb" : "#e5e7eb",
          color: done || active ? "#fff" : "#9ca3af",
          border: active ? "2px solid #93c5fd" : "2px solid transparent",
          transition: "all 0.2s",
        }}
      >
        {done ? "✓" : number}
      </div>
      <span style={{ fontSize: 12, fontWeight: 600, color: active ? "#2563eb" : done ? "#1e3a5f" : "#9ca3af" }}>
        {title}
      </span>
    </div>
  );
}
